import React from "react";

const STEPS = ["Traveller Details", "Preferred Partner Selection", "Make Payment"];

// Three-step progress header (Figma 10123:274603): completed steps turn green, the current one red.
export default function BookingStepper({ step }: { step: 1 | 2 | 3 }) {
  return (
    <ol className="gt-stepper" aria-label="Booking progress">
      {STEPS.map((label, index) => {
        const number = index + 1;
        const state = number < step ? "is-done" : number === step ? "is-current" : "";
        return (
          <li key={label} className={`gt-stepper__step ${state}`} aria-current={number === step ? "step" : undefined}>
            <span className="gt-stepper__dot">{number}</span>
            <span className="gt-stepper__label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
